import { SET_CUSTOMER_TYPE } from './actionTypes'

export const setCustomerTypeAction = (customerType) => {
    return {
        type: SET_CUSTOMER_TYPE,
        payload: {
            customerType,
        }
    }
}
